import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const ProgressBar = ({ intervalValue, currentCount }) => {
    const progress = ( currentCount / intervalValue ) * 100;

    return (
        <Box display="flex" flexDirection="column" width="100%" sx={{ mt: 2 }}>
            <LinearProgress
                variant="determinate"
                value={progress}
                style={{ width: '100%' }}
            />
            <Typography variant="body2" color="textSecondary" align="right">
                {parseFloat(progress.toFixed(3))} %
            </Typography>
        </Box>
    );
};
